import React from "react";
import RetrievalAttorneyInformationBase from "./RetrievalAttorneyInformationBase";
import { RETRIEVAL_ATTORNEY_CONFIG } from "../retrievalAttorneyConfig";
import { RETRIEVE_PLUS_IS_GUEST } from "./bondRetrieveSharedPropTypes";

const VAAttorneyInformation = ({
  globalData,
  data,
  updateData,
  role,
  isDisabled,
  isGuest,
}) => (
  <RetrievalAttorneyInformationBase
    cfg={RETRIEVAL_ATTORNEY_CONFIG.va}
    globalData={globalData}
    data={data}
    updateData={updateData}
    role={role}
    isDisabled={isDisabled}
    isGuest={isGuest}
  />
);

VAAttorneyInformation.propTypes = RETRIEVE_PLUS_IS_GUEST;

export default VAAttorneyInformation;
